export default "/images/2.svg?54df9fb6e802539c41a98e9552981a3f";